import React from 'react';
import { Bell, ChevronLeft, ChevronRight, Globe2, LogOut, Menu, Moon, Sun, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../stores/authStore';
import { useUIStore } from '../../stores/uiStore';

interface TopBarProps { title?: string; showBack?: boolean; actions?: React.ReactNode; }

export const TopBar: React.FC<TopBarProps> = ({ title, showBack, actions }) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const { user, logout } = useAuthStore();
  const { notifications, toggleNotifPanel, lang, setLang, theme, toggleTheme } = useUIStore();
  const isRTL = lang === 'ar';
  const unread = notifications.filter(item => !item.read).length;
  const BackIcon = isRTL ? ChevronRight : ChevronLeft;
  const [menuOpen, setMenuOpen] = React.useState(false);

  const toggleLanguage = () => {
    const next = isRTL ? 'en' : 'ar';
    setLang(next);
    void i18n.changeLanguage(next);
  };

  return (
    <header className="topbar">
      <div className="topbar-inner">
        {showBack && <button type="button" className="icon-control" onClick={() => navigate(-1)} aria-label={t('errors.goBack')}><BackIcon size={20} /></button>}
        <div className="topbar-brand">
          <img className="brand-emblem size-10" src="/assets/images/luxurious_gold_emblem_and_logo_design.png" alt="" />
          <div className="min-w-0">
            <p className="brand-kicker">{t('app.name')}</p>
            <p className="topbar-title">{title ?? (isRTL ? 'نظام الأرشفة الصيدلي الذكي' : 'Intelligent pharmacy archive')}</p>
          </div>
        </div>
        <div className="topbar-actions">
          {actions}
          <button type="button" className="icon-control relative" onClick={toggleNotifPanel} aria-label={isRTL ? 'الإشعارات' : 'Notifications'}><Bell size={20} />{unread > 0 && <span className="notification-dot">{unread}</span>}</button>
          <div className="desktop-utilities">
            <button type="button" className="icon-control" onClick={toggleLanguage} aria-label={isRTL ? 'Switch to English' : 'التبديل إلى العربية'}><Globe2 size={19} /></button>
            <button type="button" className="icon-control" onClick={toggleTheme} aria-label={theme === 'dark' ? t('theme.switchToLight') : t('theme.switchToDark')}>{theme === 'dark' ? <Sun size={19} /> : <Moon size={19} />}</button>
          </div>
          <button type="button" className="icon-control mobile-menu-trigger" onClick={() => setMenuOpen(value => !value)} aria-expanded={menuOpen} aria-controls="mobile-utility-menu" aria-label={isRTL ? 'قائمة الأدوات' : 'Utility menu'}>{menuOpen ? <X size={20} /> : <Menu size={20} />}</button>
        </div>
        {menuOpen && <div id="mobile-utility-menu" className={`mobile-utility-menu ${isRTL ? 'text-right' : ''}`} role="menu">
          <button type="button" role="menuitem" onClick={() => { toggleLanguage(); setMenuOpen(false); }}><Globe2 size={18} />{isRTL ? 'English' : 'العربية'}</button>
          <button type="button" role="menuitem" onClick={() => { toggleTheme(); setMenuOpen(false); }}>{theme === 'dark' ? <Sun size={18} /> : <Moon size={18} />}{theme === 'dark' ? t('theme.switchToLight') : t('theme.switchToDark')}</button>
          {user && <button type="button" role="menuitem" onClick={logout}><LogOut size={18} />{t('navigation.logout')}</button>}
        </div>}
      </div>
    </header>
  );
};
